const types = {
	FETCH_LIST_START: 'FETCH_LIST_START',
	FETCH_LIST_ERROR: 'FETCH_LIST_ERROR',
	FETCH_LIST_SUCCESS: 'FETCH_LIST_SUCCESS'
}

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/category-list/mutation-types.js